function replaceLeading(
    input: string,
    removal: string,
    replacement = '',
    sequenceRepeats = true,
): string {
    /* Must escape any backslashes */
    const regexPattern = `^(${removal.replace('\\', '\\\\')})${sequenceRepeats ? '+' : ''}`;
    const reg = new RegExp(regexPattern, 'gu');
    return input.replace(reg, replacement);
}

function replaceTrailing(
    input: string,
    removal: string,
    replacement = '',
    sequenceRepeats = true,
): string {
    /* Must escape any backslashes */
    const regexPattern = `(${removal.replace('\\', '\\\\')})${sequenceRepeats ? '+' : ''}$`;
    const reg = new RegExp(regexPattern, 'gu');
    return input.replace(reg, replacement);
}

function trim(input: string, removal = ' '): string {
    return replaceLeading(replaceTrailing(input, removal), removal);
}

const trimLeading = (input: string, removal = ' ') => replaceLeading(input, removal, '');
const trimTrailing = (input: string, removal = ' ') => replaceTrailing(input, removal, '');

const addLeading = (input: string, character: string) => {
    if (input.startsWith(character)) {
        return input;
    }
    return `${character}${input}`;
};
const addTrailing = (input: string, character: string) => {
    if (input.endsWith(character)) {
        return input;
    }
    return `${input}${character}`;
};

export default Object.freeze({
    trim,
    trimLeading,
    trimTrailing,
    replaceLeading,
    replaceTrailing,
    removeLeading: (input: string, removal: string) => replaceLeading(input, removal),
    removeTrailing: (input: string, removal: string) => replaceTrailing(input, removal),
    addLeading,
    addTrailing,
});
